function getInitChartOption() {
    return {
        xAxis: [{
            type: 'category',
            data: [
                // '总充值',
                // '总提现',
                // '总投注',
                // '返佣',
                // '线上充值',
                // '线下充值',
                // '会员赠送',
                // '转充赠送'
            ],
            axisTick: {
                alignWithLabel: true
            },
        }],
        yAxis: [{
            type: 'value',
        }],
        grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'cross',
                label: {
                    backgroundColor: '#6a7985'
                }
            }
        },
        series: [
            {
                data: [
                    // 1000,500,400,300,200,80,50,80
                    // // 820,
                    // // 932,
                    // // 901,
                    // // 934,
                    // // 1290,
                    // // 1330,
                    // // 132
                ],
                type: 'bar',
                name: '金额',
                // barWidth: '70%',
                itemStyle: {
                    normal: {
                        color: function (params) {
                            let colorList = ['#1890ff', '#c23531', '#2f4554', '#61a0a8', '#d48265', '#91c7ae', '#749f83', '#ca8622', '#D24D57']
                            return colorList[params.dataIndex]
                        }
                    }
                },
                label: {
                    normal: {
                        show: true,
                        position: 'top',
                        color: '#000'
                    }
                },
            }
        ]
    }
}

export {getInitChartOption}



// WEBPACK FOOTER //
// ./src/common/SummaryChart.js